import { Button, icon, LabelRegular, TextMedium } from "@hm/fundamental"

interface StepperInputProps {
	label: string
	formattedValue: string
	decrementAriaLabel: string
	incrementAriaLabel: string
	onDecrement: () => void
	onIncrement: () => void
	"data-cy": string
}

export const StepperInput: React.FC<StepperInputProps> = ({
	label,
	formattedValue,
	decrementAriaLabel,
	incrementAriaLabel,
	onDecrement,
	onIncrement,
	"data-cy": dataCy,
}) => (
	<div
		data-cy={dataCy}
		className="flex items-center justify-between gap-2 rounded border border-border_highlight_10 bg-background_container px-3 py-2"
	>
		<Button
			variant="tertiary"
			square
			icon={icon.mdiMinus}
			aria-label={decrementAriaLabel}
			onClick={onDecrement}
			data-cy={`${dataCy}-decrement`}
		/>
		<div className="flex flex-col items-center text-center">
			<LabelRegular className="text-foreground_faded">
				{label}
			</LabelRegular>
			<TextMedium className="text-foreground">
				{formattedValue}
			</TextMedium>
		</div>
		<Button
			variant="tertiary"
			square
			icon={icon.mdiPlus}
			aria-label={incrementAriaLabel}
			onClick={onIncrement}
			data-cy={`${dataCy}-increment`}
		/>
	</div>
)
